import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchDataModuleActions = createDataModuleActions('FETCH_CARD_ACTIVITY');
export const fetchCardActivity = fetchDataModuleActions.dataRequest;
export const fetchCardActivitySuccess = fetchDataModuleActions.dataSuccess;
export const fetchCardActivityError = fetchDataModuleActions.dataError;
export const resetFetchCardActivity = fetchDataModuleActions.dataReset;
